export * from './FooterCol';
